import { ComponentProps, FC } from 'react';
import { twMerge } from 'tailwind-merge';

import LoaderIcon from '../../../assets/icons/loader-icon';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';

type EventProcessPillProps = {
  className?: string;
} & Pick<ComponentProps<typeof AppFormattedMessage>, 'id' | 'values'>;

// "… in process ..." pill rendered by the floating queue narrator at the bottom of the
// events page (single-operation kind label or the collapsed operation count).
export const EventProcessPill: FC<EventProcessPillProps> = ({ className, id, values }) => (
  <div
    className={twMerge(
      'flex w-fit items-center gap-2 rounded-full border border-gray-100 bg-white px-4 py-2 shadow-md',
      className,
    )}
  >
    <LoaderIcon className="size-4" />
    <span className="text-nowrap text-sm font-[450] text-gray-700">
      <AppFormattedMessage id={id} values={values} />
    </span>
  </div>
);
